export default "__VITE_ASSET__CKe4oGuF__"